// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serialize Basic Care from database.
 * @see #/components/schemas/BasicCareProcedure - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface BasicCareProcedure {
    /**
     * The mona code for the basic care procedure
     * @dataFormat uuid
     */
    code: string;
    /**
     * The display name for the basic care procedure.
     *
     */
    display_name: string;
    /**
     * Determines if the record represents a procedure group
     *
     */
    is_group?: boolean;
    /**
     * The parent basic care, if grouped.
     * @dataFormat uuid
     */
    parent?: string;
    /**
     * A suggestion how long the procedure could take to perform.
     *
     */
    duration_suggested_minutes: number;
    /**
     * Determines if the procedure should be always visible, even if no record exists.
     *
     */
    always_visible: boolean;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for BasicCareProcedure
 */
export namespace BasicCareProcedure {
    /**
     * BasicCareProcedure Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The mona code for the basic care procedure
         * @dataFormat uuid
         */
        code: string;
        /**
         * The display name for the basic care procedure.
         * @type string (`dataFormat` is missing)
         */
        displayName: string;
        /**
         * Determines if the record represents a procedure group
         * @type boolean (`dataFormat` is missing)
         */
        isGroup?: boolean;
        /**
         * The parent basic care, if grouped.
         * @dataFormat uuid
         */
        parent?: string;
        /**
         * A suggestion how long the procedure could take to perform.
         * @type number (`dataFormat` is missing)
         */
        durationSuggestedMinutes: number;
        /**
         * Determines if the procedure should be always visible, even if no record exists.
         * @type boolean (`dataFormat` is missing)
         */
        alwaysVisible: boolean;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * BasicCareProcedure DTO
     * Transforms BasicCareProcedure model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend BasicCareProcedure model */
        static toModel(obj: BasicCareProcedure): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend BasicCareProcedure model */
        static toApi(obj: Model): BasicCareProcedure {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as BasicCareProcedure;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
